
    <a
      appSeleniumDirective
      [element]="element"
      href="{{element.url}}" target="_blank">{{element.urlText}}
      tabindex="{{element.tabIndex}}"
    </a>
  